import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const roomApi = createApi({
  reducerPath: "roomApi",
  baseQuery: fetchBaseQuery({ baseUrl: "/api/public" }),
  endpoints: (builder) => ({


    // GET ALL ROOM-TYPES
    getRoomTypes: builder.query({
      query: () => "/room-types",
    }),

    // GET PHONE NUMBER
    getRegisteredUserByPhone: builder.query({
      query: (phone) => `/user/phone/${phone}`,
    }),

    // GET ROOMS BY TYPE
    getRoomsByType: builder.query({
      query: ({ typeId, checkIn, checkOut }) => {
        let url = `/rooms/type/${typeId}`;
        /* 
           Only append dates if both are present. 
           If dates are missing, backend should theoretically return all rooms 
           or we can decide logic. 
        */
        if (checkIn && checkOut) {
          url += `?checkIn=${checkIn}&checkOut=${checkOut}`;
        }
        return url;
      },
    }),



    // // GET ALL BOOKINGS
    // getBookings: builder.query({
    //   query: () => "/room_bookings",
    // }),

    // // GET SINGLE BOOKING
    // getBookingById: builder.query({
    //   query: (id) => `/room_bookings/${id}`,
    // }),

    // // GET USER BY PHONE
    // getBookingByPhone: builder.query({
    //   query: (phone) => `/room_bookings/phone/${phone}`,
    // }),

    // // CREATE BOOKING
    // createBooking: builder.mutation({
    //   query: (bookingData) => ({
    //     url: "/room_bookings",
    //     method: "POST",
    //     body: bookingData,
    //   }),
    // }),

    // // UPDATE BOOKING
    // updateBooking: builder.mutation({
    //   query: ({ id, data }) => ({
    //     url: `/room_bookings/${id}`,
    //     method: "PUT",
    //     body: data,
    //   }),
    // }),

    // // DELETE BOOKING
    // deleteBooking: builder.mutation({
    //   query: (id) => ({
    //     url: `/room_bookings/${id}`,
    //     method: "DELETE",
    //   }),
    // }),
  }),
});

export const {
  useGetRoomTypesQuery,
  useGetRegisteredUserByPhoneQuery,
  useLazyGetRegisteredUserByPhoneQuery,
  useGetRoomsByTypeQuery,
  // useGetBookingsQuery,
  // useGetBookingByIdQuery,
  // useLazyGetBookingByPhoneQuery,
  // useCreateBookingMutation,
  // useUpdateBookingMutation,
  // useDeleteBookingMutation,
} = roomApi;


